import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingModule } from 'fg-library';
// import { AppLayoutComponent, AuthLayoutComponent, ProductConfigLayoutComponent } from 'fg-library'; 
import { FgClientAppLayoutComponent } from './fg-client-module/layouts/app-layout/app-layout.component';
import { FgClientAuthLayoutComponent } from './fg-client-module/layouts/auth-layout/auth-layout.component';
import { FgClientProductConfigLayoutComponent } from './fg-client-module/layouts/product-config-layout/product-config-layout.component';

const routes: Routes = [
    {
        path: '',
        component: FgClientAppLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./fg-client-module/layouts/app-layout/app-layout.module').then(m => m.FgClientAppLayoutModule)
            }
        ]
    }, {
        path: '',
        component: FgClientAuthLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./fg-client-module/layouts/auth-layout/auth-layout.module').then(m => m.FgClientAuthLayoutModule)
            }
        ]
    }, {
        path: '',
        component: FgClientProductConfigLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./fg-client-module/layouts/product-config-layout/product-config-layout.module').then(m => m.FgClientProductConfigLayoutModule)
            }
        ]
    },
    {
        path: '**',
        redirectTo: ""
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})
export class ClientAppRoutingModule extends AppRoutingModule {


}
